import React, { Component } from 'react';
import { intlShape, FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import CheckBox from '../../../shared-components/CheckBox/CheckBox';
import Button, { BUTTON_STYLE } from '../../../shared-components/Button/Button';

const LOCALE_PREFIX = 'DE/components/AgreeToSEPACheckBox/AgreeToSEPACheckBox';

export const validateSepaCheckbox = (msg) => (value, allValues, ...other) => {
    if (!allValues.isViewSepaMandate) {
        return isEmpty(msg)(value, allValues, ...other);
    }
};

export class AgreeToSEPACheckBox extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        viewSepaMandate: PropTypes.func.isRequired
    };

    render() {
        const { intl, viewSepaMandate} = this.props;
        const termsLabel = (
            <div>
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.agreeToSepa-text-1`}
                />&nbsp;
                <Button
                    data-automation-id="viewSepaAgreement"
                    btnStyle={BUTTON_STYLE.LINK}
                    className="change-link sepaLink"
                    id="viewSepaAgreement" onClick={viewSepaMandate}
                >
                    <span className="link-text change-link-text accessible-link">
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.agreeToSepa-link-text-1`}
                        />
                    </span>
                    <span className="change-link-caret" />
                </Button>&nbsp;
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.agreeToSepa-text-2`}
                />&nbsp;
            </div>

        );

        return (
            <Field
                id="terms"
                name="terms"
                label={termsLabel}
                component={CheckBox}
                validate={validateSepaCheckbox(intl.formatMessage({id: `${LOCALE_PREFIX}.agreeSepaError`}))}
            />
        );
    }
}
export default injectIntl(AgreeToSEPACheckBox);
